import React from "react";

const points = [
  {
    k: "US-based, globally engaged",
    v: "A US-incorporated firm operating remotely on behalf of clients across six continents — built for owners who live in one timezone and invest in another.",
  },
  {
    k: "London at the centre of gravity",
    v: "Our practice is anchored in prime London — W1, SW1, SW3, NW3 — with vetted trade, hospitality, and compliance networks across the city's most regulated postcodes.",
  },
  {
    k: "Independent by structure",
    v: "We never custody capital, never broker transactions, never accept vendor commissions. Our only revenue is the fee you agree in writing.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="text-xs uppercase tracking-[0.28em] text-[#6E5A4E]">About Dira Yanuar Rusdias LLC</span>
            <h2 className="font-serif-display mt-6 text-4xl md:text-5xl lg:text-6xl font-light tracking-tight text-[#2B211A] leading-[1.05]">
              A US firm with a
              <span className="italic text-[#8C735D]"> worldwide</span> client roster.
            </h2>
            <p className="mt-7 text-[#6E5A4E] text-lg leading-relaxed font-light max-w-md">
              Dira Yanuar Rusdias LLC is registered in the United States and engaged by international property owners
              across the world&rsquo;s major capitals — with prime London as our deepest area of practice.
            </p>

            <div className="mt-10 grid grid-cols-3 gap-6 max-w-md">
              <Tag label="Registered" value="Wyoming, USA" />
              <Tag label="Anchored in" value="London W1D" />
              <Tag label="Clients across" value="6 continents" />
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-12 lg:border-l border-[#D6CDBB]">
            <ul className="divide-y divide-[#D6CDBB]">
              {points.map((p, i) => (
                <li key={p.k} data-testid={`about-point-${i}`} className="py-7 grid grid-cols-[auto_1fr] gap-6 items-start">
                  <span className="font-serif-display text-3xl text-[#B89A7E] leading-none w-12">
                    0{i + 1}
                  </span>
                  <div>
                    <h3 className="font-serif-display text-2xl text-[#2B211A]">{p.k}</h3>
                    <p className="mt-2 text-[#6E5A4E] leading-relaxed">{p.v}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

function Tag({ label, value }) {
  return (
    <div className="border-t border-[#D6CDBB] pt-4">
      <div className="text-[11px] uppercase tracking-[0.28em] text-[#6E5A4E]">{label}</div>
      <div className="font-serif-display text-lg text-[#2B211A] mt-1 leading-tight">{value}</div>
    </div>
  );
}
